import { QueryClient } from '@tanstack/react-query';
import queryKeys from '../../requests/queryKeys';

/**
 * Utility function to invalidate reports queries based on user access level.
 * This ensures both custom reports and the general reports list are refetched to reflect the latest changes.
 *
 * Invalidates:
 * - Custom reports query (always)
 * - General reports list query (always)
 * - Shared custom reports query (only if user doesn't have all custom reports view access)
 *
 * Note: The custom reports query must be refetched every time since checkTitleExists depends on this query.
 *
 * @param queryClient - The React Query client instance
 * @param hasAllCustomReportsViewAccess - Whether the user has access to all custom reports
 */
const invalidateCustomReportsQuery = (queryClient: QueryClient, hasAllCustomReportsViewAccess: boolean): void => {
  queryClient.invalidateQueries({ queryKey: queryKeys.customReports.all });
  queryClient.invalidateQueries({ queryKey: queryKeys.ReportList.ReportList() });
  if (!hasAllCustomReportsViewAccess) {
    queryClient.invalidateQueries({ queryKey: queryKeys.customReports.sharedAll });
  }
};

export default invalidateCustomReportsQuery;
